/* @flow */

export default {
  root: {
    width: 32,
    height: 31,
  },
};
